import data from "../../.sourceflow/case_studies.json";
import articleData from "../../.sourceflow/articles.json";
import BaseCollection from "@sourceflow-uk/sourceflow-sdk/base_collection";

export const getCaseStudies = ({ url_slug = null, locale = "en" } = {}) => {
  const primaryCaseStudies = Array.isArray(data) ? data : data.category_values || [];

  const articlesAsCaseStudies = (articleData.category_values || []).filter(
    (item) => item.type && item.type[locale] === "Case Studies",
  );

  const combinedData = [...primaryCaseStudies, ...articlesAsCaseStudies];

  const collection = new BaseCollection(combinedData, locale)
    .orderBy((i) => parseInt(i.order?.[locale] || 0))
    .map((i) => ({
      ...i,
      href: i.url_slug ? `/${data.url_pattern || "case-studies"}/${i.url_slug}` : "#",
    }));

  if (url_slug) {
    return collection.getJsonItem(url_slug, "url_slug");
  }

  return collection.getItems();
};
